import apiClient from './apiClient'

const authService = {
  // Login user (multi-tenant support)
  login: async (username, password) => {
    try {
      const response = await apiClient.post('/tenant-auth/login', {
        username,
        password
      })
      
      // Check if tenant selection is required
      if (response.data.requiresTenantSelection) {
        // Return data for tenant selection screen
        return {
          success: true,
          requiresTenantSelection: true,
          memberships: response.data.memberships,
          temporaryToken: response.data.temporaryToken,
          user: response.data.user
        }
      }
      
      // Platform admin login - no tenant context
      if (response.data.isPlatformAdmin && response.data.token) {
        apiClient.setAuthToken(response.data.token)
        
        return {
          success: true,
          data: {
            user: response.data.user,
            token: response.data.token,
            isPlatformAdmin: true
          }
        }
      }
      
      // Single tenant or auto-selected - set token
      if (response.data.success && response.data.token) {
        apiClient.setAuthToken(response.data.token)
        
        return {
          success: true,
          data: {
            user: response.data.user,
            token: response.data.token,
            tenant: response.data.tenant,
            role: response.data.role
          }
        }
      }
      
      return response.data
    } catch (error) {
      throw error
    }
  },

  // Logout user
  logout: async () => {
    try {
      const response = await apiClient.post('/auth/logout')
      
      // Clear token from API client
      apiClient.clearAuthToken()
      
      return response.data
    } catch (error) {
      // Clear token even if logout fails
      apiClient.clearAuthToken()
      throw error
    }
  },

  // Refresh token
  refreshToken: async (refreshToken) => {
    try {
      const response = await apiClient.post('/auth/refresh', {
        refreshToken
      })
      
      // Update token in API client
      if (response.data.success && response.data.data.token) {
        apiClient.setAuthToken(response.data.data.token)
      }
      
      return response.data
    } catch (error) {
      throw error
    }
  },

  // Change password
  changePassword: async (currentPassword, newPassword, confirmPassword) => {
    try {
      const response = await apiClient.post('/auth/change-password', {
        currentPassword,
        newPassword,
        confirmPassword
      })
      
      return response.data
    } catch (error) {
      throw error
    }
  },

  // Forgot password
  forgotPassword: async (email) => {
    try {
      const response = await apiClient.post('/auth/forgot-password', {
        email
      })
      
      return response.data
    } catch (error) {
      throw error
    }
  },

  // Reset password
  resetPassword: async (token, newPassword, confirmPassword) => {
    try {
      const response = await apiClient.post('/auth/reset-password', {
        token,
        newPassword,
        confirmPassword
      })
      
      return response.data
    } catch (error) {
      throw error
    }
  },

  // Get current user
  getCurrentUser: async () => {
    try {
      const response = await apiClient.get('/auth/me')
      return response.data
    } catch (error) {
      throw error
    }
  },

  // Verify token
  verifyToken: async (token) => {
    try {
      const response = await apiClient.post('/auth/verify-token', {
        token
      })
      
      return response.data
    } catch (error) {
      throw error
    }
  }
}

export default authService